import { ConfigKey_FHIRQueryResources_Key } from '@app/fhir-shared';
import { AppConfigKey_FE } from '@nu-art/thunderstorm-frontend';
export const ConfigKeyFE_FHIRQueryResources = new AppConfigKey_FE(ConfigKey_FHIRQueryResources_Key);
//# sourceMappingURL=consts.js.map